import React from 'react';
import classes from './SlateMention.module.scss';
import { RenderElementProps, useFocused, useSelected } from 'slate-react';
import { CustomMention } from '../../../../models/slate-editor';
import classNames from 'classnames';
import { ThirdPartyProfileSearchType } from '../../../../models/graphql';

export interface SlateMentionViewProps extends RenderElementProps {
  element: CustomMention;
}

export const SlateMentionView = ({ attributes, element, children }: SlateMentionViewProps): JSX.Element => {
  const selected = useSelected();
  const focused = useFocused();
  return (
    <span
      {...attributes}
      contentEditable={false}
      data-cy={`mention-${element.displayName.replace(' ', '-')}`}
      className={classNames(classes.SlateMention, { [classes.SlateMentionSelected]: selected && focused })}>
      {element.method === ThirdPartyProfileSearchType.TWITTER_USER ? `@${element.username}` : element.displayName}
      {children}
    </span>
  );
};
